import React, { Component } from 'react'
import './novaturma.css'

export default class NoPlate extends Component {
    state={

    }
    componentDidMount(){
        
            let data = localStorage.getItem('user');
            if(data){
                let user = JSON.parse(data);
                this.setState({
                    name:user.name,
                    uid:user.uid
                })
            }
    }
    render() {
        let{
            name
        } = this.state
        return (
            <div className='main'>
                <div className='n_header'>
                    <h1>Arriba!</h1>
                </div>

              


                <div className='nn_body'>
                   <div className='main__tt'>
<p style={{cursor:'pointer'}} onClick={()=>this.props.history.goBack()}>Back</p>
                       <div className='shifts_input'>
                           <h4> Criando um novo turno</h4>
                          <input type='text'/>
                          <p>Estou disponivel nos seguintes dias e turnos</p>
                          <div className='days'>
                            <div className='day'>S</div>
                            <div className='day'>T</div>
                            <div className='day'>Q</div>
                            <div className='day'>Q</div>
                            <div className='day'>S</div>
                            <div className='day'>S</div>
                            <div className='day'>D</div>
                           
                          </div>
                       </div>
                   <div className='b_bottom'>
                       <button>Minha</button>
                       <button>Tarde</button>
                       <button>Noite</button>
                   </div>

                   <div className='bair'>
                       <p>Bairros</p>
                       <input type='search' placeholder='Search here'/>
                       <div className='list'>
                        Pardo 
                        <span>&times;</span>
                       </div>
                       <div className='list'>
                        Pardo 
                        <span>&times;</span>
                       </div>
                       <div className='list'>
                        Pardo 
                        <span>&times;</span>
                       </div>
                       <div className='list'>
                        Pardo 
                        <span>&times;</span>
                       </div>
                       <div className='list'>
                        Pardo 
                        <span>&times;</span>
                       </div>
                     
                   </div>
                   </div>
                </div>

                <div className='n_footer'>
                    <h3>CADASTRAR</h3>
                </div>
            </div>
        )
    }
}
